import React, { useEffect, useState } from "react";
import gris from "../img/gris.png";

import estilo from "./styles/Terminados.module.css";

function Terminados({ terminados }) {
  const [load, setLoad] = useState(false);

  useEffect(() => {
    setLoad(true);
  }, []);

  const reducirPalabras = (e, num) => {
    const palabras = e.split(" ");
    if (palabras.length <= num) {
      return e;
    } else {
      return palabras.slice(0, num).join(" ") + "...";
    }
  };
  return (
    <div className={estilo.contenido}>
      <div className={estilo.portada}>
        {load ? (
          <img src={terminados.portada} alt={terminados.nombre} />
        ) : (
          <img src={gris} alt="imagen de carga" />
        )}
      </div>

      <div className={estilo.datos}>
        <h2>{reducirPalabras(terminados.nombre, 8)}</h2>

        <div className={estilo.generos}>
          {terminados.generos.map((e, i) => (
            <p key={i}>{e.genero}</p>
          ))}
        </div>

        <p className={estilo.sinopsis}>
          {reducirPalabras(terminados.sinopsis, 18)}
        </p>

        <div className={estilo.ver}>
          <p>Ver Anime</p>
        </div>
      </div>
    </div>
  );
}

export default Terminados;
